import React from 'react';
import { Box, Typography, Card, CardContent, Grid } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';

const languages = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    description: 'English language interface',
  },
  {
    code: 'id',
    name: 'Bahasa Indonesia',
    flag: '🇮🇩',
    description: 'Antarmuka bahasa Indonesia',
  },
];

const infoItems = [
  'Language changes are applied immediately',
  'Your language preference is saved locally',
  'All interface elements will be translated',
];

const SettingsLanguagePage = () => {
  const { t } = useTranslation();
  const selected = i18n.language;

  const handleSelect = (code: string) => {
    i18n.changeLanguage(code);
    localStorage.setItem('appLanguage', code);
  };

  return (
    <Box sx={{ p: 4 }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <SettingsIcon sx={{ fontSize: 32, mr: 1 }} />
        <Typography variant="h4" fontWeight={700}>{t('Language Settings')}</Typography>
      </Box>

      {/* Language Selection */}
      <Card sx={{ mb: 3, p: 2, boxShadow: 2 }}>
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>{t('Select Language')}</Typography>
        <Grid container spacing={2}>
          {languages.map(lang => (
            <Grid item key={lang.code}>
              <Card
                onClick={() => handleSelect(lang.code)}
                sx={{
                  minWidth: 220,
                  borderRadius: 3,
                  boxShadow: selected === lang.code ? 6 : 1,
                  border: selected === lang.code ? '2px solid #5146e1' : '1px solid #e0e0e0',
                  cursor: 'pointer',
                  transition: 'box-shadow 0.2s, border 0.2s',
                  background: selected === lang.code ? '#5146e1' : '#fff',
                  color: selected === lang.code ? '#fff' : 'inherit',
                }}
                elevation={selected === lang.code ? 6 : 1}
              >
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <span style={{ fontSize: 24, marginRight: 8 }}>{lang.flag}</span>
                    <Typography variant="h6" fontWeight={600}>{lang.code === 'id' ? t('Bahasa Indonesia') : t('English')}</Typography>
                  </Box>
                  <Typography variant="body2" sx={{ color: selected === lang.code ? '#e0e0e0' : '#757575' }}>{t(lang.description)}</Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Card>
    </Box>
  );
};

export default SettingsLanguagePage; 